<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="600px"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        dark
        color="blue darken-1"
        block
        v-on="on"
      >
        Roll Over Leave Entitlements
      </v-btn>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Carry Over Leave Entitlement"
      text="Create Leave Entitlements For Next Year"
      class="mb-0"
    >
      <v-container>
        <v-card-title>
          <span class="headline">Are you sure?</span>
        </v-card-title>
        <v-card-text>
          This action will roll over selected leave type(s)' entitlement(s) to next year. Any extra unused leaves exceed the carry forward limit will be forfeited. 
        </v-card-text>
      </v-container>

      <v-row>
        <v-col class="py-0">
          <!-- list all leave types -->
          <v-data-table
            v-model="leaveTypesList"
            v-validate="'required'"
            :error-messages="errors.collect('leaveTypesList')"
            data-vv-name="leaveTypesList"
            data-vv-as="leave types"
            :loading="leaveTypesTableLoading"
            :headers="leaveTypesHeaders"
            dense
            :items="leaveTypes"
            hide-default-footer
            fixed-header
            disable-pagination
            class="elevation-1 mb-3"
            show-select
            item-key="id"
            item-value="name"
          >
            <template v-slot:item.name="{ item }">
              <div class="my-2">
                {{ item.name }}
              </div>
            </template>
          </v-data-table>
          <div :class="errors.first('leaveTypesList') ? 'py-0' : 'py-3'">
            <span class="red--text text--lighten-1 caption">{{ errors.first('leaveTypesList') }}</span>
          </div>
        </v-col>
      </v-row>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"       
          @click="dialog = false"
        >
          No
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"   
          class="px-10 white--text"       
          @click="submit"
        >
          Yes
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },

    data () {
      return {
        dialog: false,
        progressing: false,
        leaveTypesList: null,
        leaveTypes: [],
        leaveTypesHeaders: [
          {
            text: 'Name',
            align: 'left',
            sortable: true,
            value: 'name',
          },      
        ],
      }
    },
    created () {
      this.loadLeaveTypes()
    },

    methods: {
      submit () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return
            
            this.progressing = true

            this.$api.leaveEntitlements().createMany(this.prepareFormData())
              .then((res) => {
                if (res.status === 200) {
                  this.$emit('copied')             
                  this.$snack({ message: res.data.status })

                  this.dialog = false               
                }
              }).catch(error => {
                if (error.response.status === 500) {
                  let msg = 'Failed to create leave entitlement'
                  if (error.response.data.message.includes('Duplicate entry')) {
                    msg = 'Duplicate Leave Entitlement entry.'
                  }
                  this.$snack({ 
                    color: 'error',
                    message: msg, 
                  })
                } else if (error.response.status === 423) {
                  this.$snack({ 
                    color: 'error',
                    message: error.response.data.status, 
                  })
                } else if (error.response.status === 428) {
                } 
              }).then(() => {
                this.progressing = false
              })
          })
      },
      loadLeaveTypes () {
        this.leaveTypesTableLoading = true
        this.$api.hrisLeaveTypes().list()
          .then(res => {
            this.leaveTypes = res.data
            this.leaveTypesTableLoading = false
          })
      },
      prepareFormData () {
        return {
          selected_leave_types: this.leaveTypesList,
        }
      },
    },
  }
</script>

<style>
.v-dialog:not(.v-dialog--fullscreen) {
    max-height: 100%;
}
</style>
